export default __webpack_public_path__ + "icon9ead1d.svg";